/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Status_Last_ErrorInputs */



/**
* | output |
* | --- |
* | "Last error" |
*
* @param {Admin_Status_Last_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_status_last_error = /** @type {((inputs?: Admin_Status_Last_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Status_Last_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dernière erreur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Último error")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Último erro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ultimo errore")
	return /** @type {LocalizedString} */ ("Last error")
});